import React, { useCallback, useState } from 'react'
import { InputError, InputField, InputLabel, InputLabelText, InputWrapper } from '../index.styled'
import { filterNumber, formatCurrencyOfTextInput } from '../../../../../helper'


const CurrencyInputControlled = React.memo(({
	name,
	label = '',
	defaultValue,
	readOnly,
	value,
	autoFocus,
	testId,
	tabIndex,
	color,
	autoComplete,
	disabled,
	size,
	className,
	errorMessage,
	hasLongError = false,
	hasLongTextError = false,
	allowNegative = false,
	onChange = () => {},
	setValue,
	onBlur = () => {
	},
	onFocus = () => {
	},
	placeholder,
	inputMode,
	refInput = null,
}) => {

	const [focused, setFocused] = useState(false)
	const errorClass = (hasLongError ? 'error-big' : 'error') + (hasLongTextError ? ' error-big-text' : '')

	const handleFocus = useCallback(() => {
		setFocused(true)
		onFocus()
	}, [onFocus])

	const handleChange = useCallback((e) => {
		let inputValue = e.target.value
		if (allowNegative) {
			inputValue = inputValue.replace(/[^0-9.,-]/g, '')
		} else {
			inputValue = filterNumber(inputValue).replace('.', ',')
		}
		setValue(inputValue)
		onChange()
	}, [onChange, setValue, allowNegative])

	const handleBlur = () => {
		setFocused(false)
		if (value) {
			const formattedValue = value === ',' || value === '.' ? '0' : value
			formatCurrencyOfTextInput(formattedValue, (formattedValue) => setValue(formattedValue))
		}
		onBlur()
	}

	const labelUp = focused || readOnly || defaultValue || (value || value === 0)
	const layout = (focused ? 'focus ' : '') + (errorMessage ? `${errorClass} ` : '') + (labelUp ? '' : 'toggled ') + (disabled ? 'disabled ' : '') + (color ? color + ' ' : '') + size + ' ' + className

	return (
		<InputWrapper className={layout}>
			{errorMessage && <InputError className={layout}>{errorMessage}</InputError>}
			<InputLabel className={layout}>
				<InputLabelText className={layout}>{label}</InputLabelText>
				<InputField data-testid={testId ?? null}
										id={name}
										name={name}
										ref={refInput}
										value={value}
										type="text"
										autoFocus={autoFocus}
										autoComplete={autoComplete || 'off'}
										role="presentation"
										onFocus={handleFocus}
										className={layout}
										readOnly={readOnly}
										onBlur={handleBlur}
										tabIndex={tabIndex}
										disabled={disabled}
										onChange={handleChange}
										placeholder={placeholder}
										inputMode={inputMode} />
			</InputLabel>
		</InputWrapper>
	)
})

CurrencyInputControlled.displayName = 'CurrencyInputControlled'
export default CurrencyInputControlled
